import showMessage from "components/showMessage";
import options from "contexts/options.json";
import { useEffect, useMemo, useRef, useState } from "react";
import { CANCEL_STATUS } from "contexts/enviroments";
import { ObjectId } from "mongodb";
import { useMongoDB } from "./MongoDBContext";

//--------------------------------------- Newly Added to avoid graphQL.  For auto implement relations ---------------------------------------
import * as bookingRelations from 'app_services/data_sources/mongodb-atlas/Booking/bookings/relationships.json'
import * as dailynoticesRelations from 'app_services/data_sources/mongodb-atlas/Booking/dailynotices/relationships.json'
import * as filesRelations from 'app_services/data_sources/mongodb-atlas/Booking/files/relationships.json'
import * as messagesRelations from 'app_services/data_sources/mongodb-atlas/Booking/messages/relationships.json'
import * as opening_timesRelations from 'app_services/data_sources/mongodb-atlas/Booking/opening_times/relationships.json'
import * as sequenceRelations from 'app_services/data_sources/mongodb-atlas/Booking/sequence/relationships.json'
import * as userRelations from 'app_services/data_sources/mongodb-atlas/Booking/user/relationships.json'
import * as clinicsRelations from 'app_services/data_sources/mongodb-atlas/Booking/clinics/relationships.json'
import * as docksRelations from 'app_services/data_sources/mongodb-atlas/Booking/docks/relationships.json'
import * as patientsRelations from 'app_services/data_sources/mongodb-atlas/Booking/patients/relationships.json'
import * as subscriptionsRelations from 'app_services/data_sources/mongodb-atlas/Booking/subscriptions/relationships.json'
import * as visitsRelations from 'app_services/data_sources/mongodb-atlas/Booking/visits/relationships.json'

/**
 * Atlas App Service's relation definition
 */
interface RelationDefinition {
    ref: string;
    source_key: string;
    foreign_key: string;
    is_list: boolean;
}

const relations: { [key:string]: { [key:string]: RelationDefinition  } } = {
    bookings: bookingRelations,
    dailynotices: dailynoticesRelations,
    files: filesRelations,
    messages: messagesRelations,
    opening_times: opening_timesRelations,
    sequence: sequenceRelations,
    user: userRelations,
    clinics: clinicsRelations,
    docks: docksRelations,
    patients: patientsRelations,
    subscriptions: subscriptionsRelations,
    visits: visitsRelations,
}

let mongoCollectionWatch: AsyncGenerator<Realm.Services.MongoDB.ChangeEvent<any>> | null = null

export const translateEvent = (v: KV): CalendarEvent => {
    const { _id: id, start, end, resourceId, clinicID, modalityID, body1, body2, contrast, checkin, ivCheckin, clinicName, patientID, patientName, userID, bookingType, bookingMethod, files, comment, walkingStatus, bookingStatus, appointmentMethod, doctor, doctorID, interviewType, dockID, visitID, delay, updated } = v
    return ({
            id, title: options.bookingType[bookingType], start, end, resourceId: v.modalityID, extendedProps: {
            id, clinicID, modalityID, body1, body2, contrast, checkin, ivCheckin, clinicName, patientID, patientName, userID,
            bookingType, bookingMethod, appointmentMethod, files, comment, walkingStatus, bookingStatus, doctor, doctorID, interviewType, dockID, visitID, delay, updated
        }
    })
}

export const translateEventMonth = (v: KV): CalendarEvent => {
    return ({
        id: v._id.date + v._id.modality, title: v._id.modality, start: v._id.date, end: v._id.date, resourceId: v._id.modality, extendedProps: {
            id: v._id, count: v.count, duration: v.duration
        }
    })
}


export const useFindBookings = (db?: Realm.Services.MongoDBDatabase | null, dateRange?: { start?: Date | null, end?: Date | null }, modalities?: KV, noSummarize?: boolean) => {
    const appDb = useMongoDB()?.db
    const actualDb = db || appDb
    const startTime = dateRange?.start?.getTime();
    const endTime = dateRange?.end?.getTime();
    const [result, setResult] = useState<{ data?: CalendarEvent[] | null, loading?: boolean, error?: Error | null, refetch?: () => Promise<void> }>({
        data: null,
        loading: false,
        error: null
    })
    const eventsReference = useRef<CalendarEvent[] | null | undefined>([])
    eventsReference.current = result.data

    // Removed.  This dunction is for watching db update and reflect it.
    // const updateEvent = (change: Realm.Services.MongoDB.ChangeEvent<any>) => {
    //     const monthView = (dateRange?.end?.getTime() || 0) - (dateRange?.start?.getTime() || 0) > 12096e5
    //     if (monthView) return;
    //     switch (change.operationType) {
    //         case "insert": {
    //             const { documentKey, fullDocument } = change;
    //             const index = (eventsReference.current || []).findIndex(v => v.id === documentKey._id)
    //             if (index > -1) setResult({ loading: false, data: eventsReference.current?.map((v, i) => i === index ? translateEvent(fullDocument) : v), error: null })
    //             else setResult({ loading: false, data: [...(eventsReference.current || []), translateEvent(fullDocument)], error: null })
    //             break;
    //         }
    //         case "update":
    //         case "replace": {
    //             const { documentKey, fullDocument } = change;
    //             const index = (eventsReference.current || []).findIndex(v => v.id === documentKey._id)
    //             if (index > -1) {
    //                 if (fullDocument.canceledAt) setResult({ loading: false, data: eventsReference.current?.filter((v, i) => i !== index), error: null })
    //                 else setResult({ loading: false, data: eventsReference.current?.map((v, i) => i === index ? translateEvent(fullDocument) : v), error: null })
    //             } else { setResult({ loading: false, data: [...(eventsReference.current || []), translateEvent(fullDocument)], error: null }) }
    //             break;
    //         }
    //         case "delete": {
    //             const { documentKey } = change;
    //             const index = (eventsReference.current || []).findIndex(v => v.id === documentKey._id)
    //             if (index > -1) { setResult({ loading: false, data: eventsReference.current?.filter((v, i) => i !== index), error: null }) }
    //             break;
    //         }
    //         default:
    //     }
    // }

    const fetchData = async () => {
        if (!actualDb || !dateRange || !dateRange.start || !dateRange.end || (modalities?.length === 0)) {
            setResult({
                loading: false,
                data: null,
                error: null,
            });
            return
        }
        setResult({
            loading: true,
            data: null,
            error: null,
        });
        const monthView = noSummarize ? false : (dateRange.end.getTime() - dateRange.start.getTime() > 12096e5)
        try {
            const data: KV = monthView ?
                await actualDb.collection("bookings").aggregate([
                    { $match: { start: { $gte: dateRange.start, $lt: dateRange.end }, bookingStatus: { $ne: CANCEL_STATUS }, ...(Array.isArray(modalities) ? { modalityID: { $in: modalities } } : {}) } },
                    {
                        $group: {
                            _id: { date: { $dateTrunc: { date: "$start", unit: "day", timezone: "+09:00" } }, modality: "$modalityID" },
                            duration: { $sum: { $dateDiff: { startDate: "$start", endDate: "$end", unit: "minute", timezone: "+09:00" } } },
                            count: { $sum: 1 }
                        }
                    },
                ])
                :
                await actualDb.collection("bookings").find({ start: { $gte: dateRange.start, $lt: dateRange.end }, bookingStatus: { $ne: CANCEL_STATUS }, ...(Array.isArray(modalities) ? { modalityID: { $in: modalities } } : {}) })
            setResult({
                data: data.map((v: KV) => monthView ? translateEventMonth(v) : translateEvent(v)),
                loading: false,
                error: null,
                refetch: fetchData
            });
        } catch (err) {
            setResult({
                data: null,
                loading: false,
                error: (err instanceof Error) ? err : null,
            });
        }
        try {
            if (mongoCollectionWatch) {
                mongoCollectionWatch.return(null)
                mongoCollectionWatch = null
            }
            if (monthView) return; // no watching for month view
            // mongoCollectionWatch = db.collection("bookings").watch({ filter: { $or: [{ operationType: 'delete' }, { 'fullDocument.start': { $gte: dateRange.start, $lt: dateRange.end } }] } });
            // try {
            //     for await (const change of mongoCollectionWatch) {
            //         try {
            //             updateEvent(change)
            //         } catch (err) {
            //             if (err instanceof Error) await showMessage(`予約データ読み込み中にエラーが発生しました。\r\n ${(err as Error).message}`, { error: true })
            //             console.log(`Error updating changed booking data.  ${(err as Error)?.message}`)
            //         }
            //     }
            // } catch (err) {
            //     //error happens on reload.  ignore
            // }
        } catch (err) {
            if (err instanceof Error) await showMessage(`予約データのウオッチ設定中にエラーが発生しました。\r\n ${(err as Error).message}`, { error: true })
        }

    }

    useEffect(() => {
        fetchData();
        return () => {
            try {
                if (mongoCollectionWatch) {
                    mongoCollectionWatch.return(null)
                    mongoCollectionWatch = null
                }
            } catch (err) {
                alert(`Error removing watching stream.  ${(err as Error).message}`)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [db, startTime, endTime, modalities]) // initially db is null
    return result
}

export const translateVisitEvent = (v: KV): CalendarEvent => {
    return ({
        id: v._id, title: options.bookingType[v.bookingType], start: v.start, end: v.end, extendedProps: {
            id: v._id, clinicID: v.clinicID, ivCheckin: v.ivCheckin, clinicName: v.clinicName, patientID: v.patientID, patientName: v.patientName,
            bookingType: v.bookingType, files: v.files, comment: v.comment, bookingStatus: v.bookingStatus,
            doctor: v.doctor, doctorID: v.doctorID, 
            dockID: v.dockID, courseName: v.courseName, updated: v.updated
        }
    })
}


export const useFindVisitsNoStream = (db?: Realm.Services.MongoDBDatabase | null, dateRange?: { start?: Date | null, end?: Date | null }, modalities?: KV) => {
    const appDb = useMongoDB()?.db
    const actualDb = db || appDb
    const startTime = dateRange?.start?.getTime();
    const endTime = dateRange?.end?.getTime();
    const [result, setResult] = useState<{ data?: CalendarEvent[] | null, loading?: boolean, error?: Error | null }>({
        data: null,
        loading: false,
        error: null,
    })
    const eventsReference = useRef<CalendarEvent[] | null | undefined>([])
    eventsReference.current = result.data

    useEffect(() => {
        async function fetchData() {
            if (!actualDb || !dateRange || !dateRange.start || !dateRange.end || (modalities?.length === 0)) {
                setResult({
                    loading: false,
                    data: null,
                    error: null,
                });
                return
            }
            setResult({
                loading: true,
                data: null,
                error: null,
            });
            const monthView = dateRange.end.getTime() - dateRange.start.getTime() > 12096e5
            try {
                const data: KV = monthView ?
                    await actualDb.collection("visits").aggregate([
                        { $match: { start: { $gte: dateRange.start, $lt: dateRange.end }, bookingStatus: { $ne: CANCEL_STATUS }, ...(Array.isArray(modalities) ? { modalityID: { $in: modalities } } : {}) } },
                        {
                            $group: {
                                _id: { date: { $dateTrunc: { date: "$start", unit: "day", timezone: "+09:00" } }, modality: "$modalityID" },
                                duration: { $sum: { $dateDiff: { startDate: "$start", endDate: "$end", unit: "minute", timezone: "+09:00" } } },
                                count: { $sum: 1 }
                            }
                        },
                    ])
                    :
                    await actualDb.collection("visits").find({ start: { $gte: dateRange.start, $lt: dateRange.end }, bookingStatus: { $ne: CANCEL_STATUS }, ...(Array.isArray(modalities) ? { modalityID: { $in: modalities } } : {}) })
                setResult({
                    data: data.map((v: KV) => translateVisitEvent(v)),
                    loading: false,
                    error: null,
                });
            } catch (err) {
                setResult({
                    data: null,
                    loading: false,
                    error: (err instanceof Error) ? err : null,
                });
            }
            try {
                if (mongoCollectionWatch) {
                    mongoCollectionWatch.return(null)
                    mongoCollectionWatch = null
                }
                if (monthView) return; // no watching for month view
                // mongoCollectionWatch = db.collection("visits").watch({ filter: { $or: [{ operationType: 'delete' }, { 'fullDocument.start': { $gte: dateRange.start, $lt: dateRange.end } }] } });
                // try {
                //     for await (const change of mongoCollectionWatch) {
                //         try {
                //             updateEvent(change)
                //         } catch (err) {
                //             if (err instanceof Error) await showMessage(`予約データ読み込み中にエラーが発生しました。\r\n ${(err as Error).message}`, { error: true })
                //             console.log(`Error updating changed visit data.  ${(err as Error)?.message}`)
                //         }
                //     }
                // } catch (err) {
                //     //error happens on reload.  ignore
                // }
            } catch (err) {
                if (err instanceof Error) await showMessage(`予約データのウオッチ設定中にエラーが発生しました。\r\n ${(err as Error).message}`, { error: true })
            }

        }
        fetchData();
        return () => {
            try {
                if (mongoCollectionWatch) {
                    mongoCollectionWatch.return(null)
                    mongoCollectionWatch = null
                }
            } catch (err) {
                alert(`Error removing watching stream.  ${(err as Error).message}`)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [db, startTime, endTime, modalities]) // initially db is null
    return result
}

export const useFindVisits = (db?: Realm.Services.MongoDBDatabase | null, dateRange?: { start?: Date | null, end?: Date | null }, modalities?: KV) => {
    const appDb = useMongoDB()?.db
    const actualDbBase = db || appDb
    const startTime = dateRange?.start?.getTime();
    const endTime = dateRange?.end?.getTime();
    const eventsReference = useRef<CalendarEvent[] | null | undefined>([])

    // Put currentModalities null to cancel modalities setting and select all modalities.  If undefined, modalities setting is used.
    const fetchData = async (currentDb?: Realm.Services.MongoDBDatabase | null, currentDateRange?: { start?: Date | null, end?: Date | null }, currentModalities?: KV) => {
        const actualDb = currentDb || actualDbBase
        const actualDateRange = currentDateRange || dateRange
        const actualModalities = currentModalities === undefined ? modalities : currentModalities
        if (!actualDb || !actualDateRange || !actualDateRange.start || !actualDateRange.end || (actualModalities?.length === 0)) {
            setResult(current => ({ ...current,
                loading: false,
                data: null,
                error: null,
            }));
            return
        }
        setResult(current => ({ ...current,
            loading: true,
            data: null,
            error: null,
        }));
        const monthView = actualDateRange.end.getTime() - actualDateRange.start.getTime() > 12096e5
        try {
            const data: KV = monthView ?
                await actualDb.collection("visits").aggregate([
                    { $match: { start: { $gte: actualDateRange.start, $lt: actualDateRange.end }, bookingStatus: { $ne: CANCEL_STATUS }, ...(Array.isArray(actualModalities) ? { modalityID: { $in: actualModalities } } : {}) } },
                    {
                        $group: {
                            _id: { date: { $dateTrunc: { date: "$start", unit: "day", timezone: "+09:00" } }, modality: "$modalityID" },
                            duration: { $sum: { $dateDiff: { startDate: "$start", endDate: "$end", unit: "minute", timezone: "+09:00" } } },
                            count: { $sum: 1 }
                        }
                    },
                ])
                :
                await actualDb.collection("visits").find({ start: { $gte: actualDateRange.start, $lt: actualDateRange.end }, bookingStatus: { $ne: CANCEL_STATUS }, ...(Array.isArray(actualModalities) ? { modalityID: { $in: actualModalities } } : {}) })
            setResult(current => ({ ...current,
                data: data.map((v: KV) => translateVisitEvent(v)),
                loading: false,
                error: null,
            }));
        } catch (err) {
            setResult(current => ({ ...current,
                data: null,
                loading: false,
                error: (err instanceof Error) ? err : null,
            }));
        }
    }

    const [result, setResult] = useState<{ data?: CalendarEvent[] | null, loading?: boolean, error?: Error | null, refetch: (db?: Realm.Services.MongoDBDatabase | null, dateRange?: { start?: Date | null, end?: Date | null }, modalities?: KV) => Promise<void> }>({
        data: null,
        loading: false,
        error: null,
        refetch: fetchData
    })
    eventsReference.current = result.data


    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [db, startTime, endTime, modalities]) // initially db is null
    return result
}

//--------------------------------------- Newly Added to avoid graphQL ---------------------------------------
// const client = new MongoClient(process.env.REACT_APP_MONGO_URL || '');


const parseRelationDefinition = async (relationDefinition: RelationDefinition, pipeline: KV[] = []):Promise<any[]> => {
    if (
      relationDefinition.ref &&
      relationDefinition.source_key &&
      relationDefinition.foreign_key
    ) {
      const refParts = relationDefinition.ref.split("/");
      if (refParts.length !== 5 || refParts[0] !== "#" || refParts[1] !== "relationship" || refParts[2] !== "mongodb-atlas") {
        throw new Error("Invalid ref format");
      }
      const col_name = refParts[4];
  
      const lookupStage: any = {
        $lookup: {
            from: col_name,
            localField: relationDefinition.source_key,
            foreignField: relationDefinition.foreign_key,
            as: relationDefinition.source_key,
        },
      };
      pipeline.push(lookupStage);
      if (!relationDefinition.is_list) {
        pipeline.push({ $unwind: {
            path: `$${relationDefinition.source_key}`,
            preserveNullAndEmptyArrays: true
        }});
      }
    }
    return pipeline;
}

/**
 * Alternative for Apollo Client's query in MongoDB
 * @returns 
 */
export const useMongoQueryDirect = () => {
    const db = useMongoDB()?.db // For using Realm without graphQL until Sep 2025
    const fetch = async <T extends KV | KV[] = KV> (collection:string, query:KV, isMany:boolean = false, options:KV = {}):Promise<{ data?:T, error?:Error }> => {
        try {
            // await client.connect();
            // const db = client.db('Booking');
            if (!db || options.skip) {
                return { data:undefined, error: undefined }
            }
            const relation = Object.keys(relations[collection]).length ? relations[collection] : null;
            if (relation) {
                const pipeline:KV[] = [{ $match: query }];
                Object.keys(relation).forEach(key => parseRelationDefinition(relation[key], pipeline))
                pipeline.push({ $limit: 1 });
                const results: KV[] = await db.collection(collection).aggregate(pipeline);
                return isMany ? { data: results as T, error: undefined } : { data: results[0] as T, error: undefined }
            } else {
                const result = isMany ? (await db.collection(collection).find(query, options)) : (await db.collection(collection).findOne(query, options));
                return { data:result, error: undefined };
            }
        } catch (err) {
            if (err instanceof Error) return { data: undefined, error: err};
        }
        return { data: undefined, error: undefined };
    }
    return fetch;
}

/**
 * Alternative for useQuery of Apollo Client in MongoDB
 * @param collection Collection name to query
 * @param query Same as query in find function
 * @param options Same as options in find function
 * @param onCompleted Function executed after getting result
 * @returns 
 */
export const useMongoQuery = (collection:string, query:KV, options:KV = {}, onCompleted?: (result:KV) => void) => {
    const db = useMongoDB()?.db // For using Realm without graphQL until Sep 2025
    const [memoizedQuery, memorizedOption] = useMemo(() => [query, options], [JSON.stringify(query), JSON.stringify(options)]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<KV|undefined>();
    const [error, setError] = useState<Error>();
    const refetch = async () => {
        setLoading(true);
        setData(undefined)
        setError(undefined);
        try {
            // await client.connect();
            // const db = client.db('Booking');
            if (!db || options.skip) {
                setLoading(false)
                return
            }
            const relation = Object.keys(relations[collection]).length ? relations[collection] : null;
            if (relation) {
                const pipeline:KV[] = [{ $match: query }];
                Object.keys(relation).forEach(key => parseRelationDefinition(relation[key], pipeline))
                pipeline.push({ $limit: 1 });
                const results: KV[] = await db.collection(collection).aggregate(pipeline);
                setData(results[0])
                onCompleted && onCompleted(results[0])
            } else {
                const result = await db.collection(collection).findOne(query, options);
                setData(result);
                onCompleted && onCompleted(result)
            }
        } catch (err) {
            if (err instanceof Error) setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refetch();
    }, [db, collection, memoizedQuery, memorizedOption]);
    
    return { loading, data, error, refetch };
}

/**
 * Alternative for useQuery(Multiple results) of Apollo Client in MongoDB
 * @param collection Collection name to query
 * @param query Same as query in find function
 * @param options Same as options in find function
 * @param onCompleted Function executed after getting result
 * @returns 
 */
export const useMongoQueries = (collection:string, query:KV, options:KV = {}, onCompleted?: (results:KV[]) => void) => {
    const db = useMongoDB()?.db // For using Realm without graphQL until Sep 2025
    const [memoizedQuery, memorizedOption] = useMemo(() => [query, options], [JSON.stringify(query), JSON.stringify(options)]);

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<KV[]|undefined>();
    const [error, setError] = useState<Error>();
    const refetch = async () => {
        setLoading(true);
        setData(undefined)
        setError(undefined);
        try {
            // await client.connect();
            // const db = client.db('Booking');
            if (!db || options.skip) {
                setLoading(false)
                return
            }
            const relation = Object.keys(relations[collection]).length ? relations[collection] : null;
            if (relation) {
                const pipeline:KV[] = [{ $match: query }];
                Object.keys(relation).forEach(key => parseRelationDefinition(relation[key], pipeline))
                const results: KV[] = await db.collection(collection).aggregate(pipeline);
                setData(results)
                onCompleted && onCompleted(results)
            } else {
                // const cursor = db.collection(collection).find(query, options);
                // const results = await cursor.toArray();
                const results = await db.collection(collection).find(query, options);
                setData(results);
                onCompleted && onCompleted(results)
            }
        } catch (err) {
            if (err instanceof Error) setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refetch();
    }, [db, collection, memoizedQuery, memorizedOption]);
    
    return { loading, data, error, refetch };
}

/**
 * Alternative for useLazyQuery of Apollo Client in MongoDB
 * @param collection Collection name to query
 * @param options Same as options in find function
 * @param onCompleted Function executed after getting result
 * @returns 
 */
export const useMongoLazyQuery = (collection:string, options:KV = {}, onCompleted?: (result:KV) => void):[(query:KV) => Promise<void>, { called: boolean, loading:boolean, data?:KV, error?:Error}] => {
    const db = useMongoDB()?.db // For using Realm without graphQL until Sep 2025
    const [called, setCalled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<KV|undefined>();
    const [error, setError] = useState<Error>();
    const refetch = async (query:KV) => {
        setCalled(true);
        setLoading(true);
        setData(undefined);
        setError(undefined);
        try {
            // await client.connect();
            // const db = client.db('Booking');
            if (!db || options.skip) {
                setLoading(false)
                return
            }
            const relation = Object.keys(relations[collection]).length ? relations[collection] : null;
            if (relation) {
                const pipeline: KV[] = [{ $match: query }];
                Object.keys(relation).forEach(key => parseRelationDefinition(relation[key], pipeline))
                pipeline.push({ $limit: 1 });
                const results: KV[] = await db.collection(collection).aggregate(pipeline);
                setData(results[0])
                onCompleted && onCompleted(results[0])
            } else {
                const result = await db.collection(collection).findOne(query, options);
                setData(result);
                onCompleted && onCompleted(result)
            }
        } catch (err) {
            if (err instanceof Error) setError(err);
        } finally {
            setLoading(false);
        }
    };

    return [refetch, { called, loading, data, error }];
}

/**
 * Alternative for useLazyQuery(Multiple results) of Apollo Client in MongoDB
 * @param collection Collection name to query
 * @param options Same as options in find function
 * @param onCompleted Function executed after getting result
 * @returns 
 */
export const useMongoLazyQueries = (collection:string, options:KV = {}, onCompleted?: (results:KV[]) => void):[(query:KV) => Promise<void>, { called: boolean, loading:boolean, data?:KV, error?:Error}] => {
    const db = useMongoDB()?.db // For using Realm without graphQL until Sep 2025
    const [called, setCalled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<KV[]|undefined>();
    const [error, setError] = useState<Error>();
    const refetch = async (query:KV) => {
        setCalled(true);
        setLoading(true);
        setData(undefined)
        setError(undefined);
        try {
            // await client.connect();
            // const db = client.db('Booking');
            if (!db || options.skip) {
                setLoading(false)
                return
            }
            const relation = Object.keys(relations[collection]).length ? relations[collection] : null;
            if (relation) {
                const pipeline:KV[] = [{ $match: query }];
                Object.keys(relation).forEach(key => parseRelationDefinition(relation[key], pipeline))
                const results: KV[] = await db.collection(collection).aggregate(pipeline);
                setData(results)
                onCompleted && onCompleted(results)
            } else {
                // const cursor = db.collection(collection).find(query, options);
                // const results = await cursor.toArray();
                const results = await db.collection(collection).find(query, options);
                setData(results);
                onCompleted && onCompleted(results)
            }
        } catch (err) {
            if (err instanceof Error) setError(err);
        } finally {
            setLoading(false);
        }
    };

    return [refetch, { called, loading, data, error }];
}

/**
 * Alternative for useMutation(update) of Apollo Client in MongoDB
 * @param collection Collection name to mutate
 * @param isMany Set true if updating multiple documents
 * @param options Same as options in update function
 * @param onCompleted Function executed after update
 * @returns In data, returns document in single update.
 */
export const useMongoUpdate = (collection:string, isMany: boolean = false, options:KV = {}, onCompleted?: () => void) => {
    const db = useMongoDB()?.db // For using Realm without graphQL until Sep 2025
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<KV>();
    const [error, setError] = useState<Error>();

    const mutate = async (updateQuery:KV, updateData:KV) => {
        if (!db) return { data: undefined }
        setLoading(true);
        setData(undefined);
        setError(undefined);
        let result:KV|undefined;
        try {
            // await client.connect();
            // const db = client.db('Booking');
            if (isMany) await db.collection(collection).updateMany(updateQuery, { $set: updateData }, options);
            else {
                result = await db.collection(collection).findOneAndUpdate(updateQuery, { $set: updateData }, options);
                // result = await db.collection(collection).findOneAndUpdate(updateQuery, updateData, options);
                setData(result);
            }
            onCompleted && onCompleted()
        } catch (err) {
            if (err instanceof Error) setError(err);
        } finally {
          setLoading(false);
        }
        return { data: result }
    };
      return [mutate, { loading, data, error }] as [(updateQuery:KV, updateData:KV) => Promise<{ data?: KV }>, { loading: boolean; data?: KV; error?: Error; }];

}

/**
 * Alternative for useMutation(add) of Apollo Client in MongoDB
 * @param collection Collection name to mutate
 * @param onCompleted Function executed after add
 * @returns _id of document is returned as id when mutate is executed.
 */
export const useMongoAdd = (collection:string, onCompleted?: () => void) => {
    const db = useMongoDB()?.db // For using Realm without graphQL until Sep 2025
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState<ObjectId>();
    const [error, setError] = useState<Error>();

    const mutate = async (insertData:KV) => {
        if (!db) return
        setLoading(true);
        setId(undefined);
        setError(undefined);
        try {
            // await client.connect();
            // const db = client.db('Booking');
            const result = await db.collection(collection).insertOne(insertData); // Does not accept option in Realm   , options);
            setId(result.insertedId);
            onCompleted && onCompleted()
        } catch (err) {
            if (err instanceof Error) setError(err);
        } finally {
          setLoading(false);
        }
      };
    
      return [mutate, { loading, id, error }] as [(insertData:KV) => Promise<void>, { loading: boolean; id?: ObjectId; error?: Error; }];

}

/**
 * Alternative for useMutation(add multiple) of Apollo Client in MongoDB
 * @param collection Collection name to mutate
 * @param onCompleted Function executed after add
 * @returns _id of document is returned as id when mutate is executed.
 */
export const useMongoAdds = (collection:string, onCompleted?: () => void) => {
    const db = useMongoDB()?.db // For using Realm without graphQL until Sep 2025
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState<Realm.Services.MongoDB.InsertManyResult<any>>();
    const [error, setError] = useState<Error>();

    const mutate = async (insertData:KV[]) => {
        if (!db) return
        setLoading(true);
        setResult(undefined);
        setError(undefined);
        try {
            // await client.connect();
            // const db = client.db('Booking');
            const insertResult = await db.collection(collection).insertMany(insertData); // Does not accept option in Realm   , options);
            setResult(insertResult);
            onCompleted && onCompleted()
        } catch (err) {
            if (err instanceof Error) setError(err);
        } finally {
          setLoading(false);
        }
      };
    
      return [mutate, { loading, result, error }] as [(insertData:KV) => Promise<void>, { loading: boolean; result?: Realm.Services.MongoDB.InsertManyResult<any>; error?: Error; }];

}

/**
 * Alternative for useMutation(delete) of Apollo Client in MongoDB
 * @param collection Collection name to mutate
 * @param isMany Set true if deleting multiple documents
 * @param options Same as options in delete function
 * @param onCompleted Function executed after delete
 * @returns In data, returns deleted document in single delete.
 */
export const useMongoDelete = (collection:string, isMany: boolean = false, options:KV = {}, onCompleted?: () => void) => {
    const db = useMongoDB()?.db // For using Realm without graphQL until Sep 2025
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<KV>();
    const [error, setError] = useState<Error>();

    const mutate = async (deleteQuery:KV) => {
        if (!db) return
        setLoading(true);
        setData(undefined)
        setError(undefined);
        try {
            // await client.connect();
            // const db = client.db('Booking');
            if (isMany) await db.collection(collection).deleteMany(deleteQuery); // Does not accept option in Realm   , options);
            else {
                const result = await db.collection(collection).findOneAndDelete(deleteQuery, options);
                setData(result);
            }
            onCompleted && onCompleted();
        } catch (err) {
            if (err instanceof Error) setError(err);
        } finally {
          setLoading(false);
        }
      };
    
      return [mutate, { loading, data, error }] as [(deleteQuery:KV) => Promise<void>, { loading: boolean; data?: KV; error?: Error; }];

}
